export { modal }

import { uuidv4 } from '@/utils/Uuid'

var modal = {
  props: {
    id: {
      type: String,
      required: false,
      default: 'modal-' + uuidv4(),
    },
  },
  data() {
    return {
      shown: false,
    }
  },
  mounted() {
    this.$bus.$on('open-modal', (id) => {
      if (id === this.id && !this.shown) this.openModal(id)
    })

    $('#' + this.id).on('hidden.bs.modal', () => {
      this.shown = false
    })
    window.addEventListener('keydown', this.handleEscClose)
  },
  methods: {
    handleEscClose(event) {
      if (event.key === 'Escape' && this.shown) {
        this.closeModal()
      }
    },
    openModal(id) {
      this.shown = true
      const thisId = id ? id : this.id
      $('#' + thisId).modal({
        backdrop: 'static',
        keyboard: true,
      })
    },
    closeModal() {
      this.shown = false
      $('#' + this.id).modal('hide')
    },
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEscClose) // Cleanup
  },
}
